export default __webpack_public_path__ + "static/media/sabina.9f2c314a.jpg";